<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="pgepubid00000">THE MAN FROM ARCHANGEL</h1>
<h2 class="c sigil_not_in_toc" id="pgepubid00001">and Other Tales of Adventure</h2>
<h2 class="sigilnotintoc sigil_not_in_toc" id="pgepubid00002">A. CONAN DOYLE</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001_split_000.vue?837d55c8